import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { formatError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("gagandeep@gram.global");
  const [password, setPassword] = useState("Gram@2026");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, password);
      nav("/dashboard");
    } catch (e) {
      setErr(formatError(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:block relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1541447271487-09612b3f49f7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" alt=""
             className="absolute inset-0 w-full h-full object-cover"/>
        <div className="absolute inset-0 bg-[hsl(20_20%_10%_/_0.55)]"/>
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <div className="text-[11px] uppercase tracking-[0.3em] opacity-80">GRAM Strategic Advisors LLP</div>
          <h1 className="font-serif-display text-4xl mt-2 leading-tight">A single operating system for real-estate sales.</h1>
          <p className="opacity-80 mt-3 max-w-md">Mandate. Retail. Home Loan. Every lead, visit and booking — one source of truth.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 bg-background">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="mb-8">
            <div className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground">Sign in</div>
            <h2 className="font-serif-display text-3xl mt-1">Welcome back</h2>
          </div>
          <div className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required data-testid="login-email-input"/>
            </div>
            <div>
              <Label htmlFor="pw">Password</Label>
              <Input id="pw" type="password" value={password} onChange={e => setPassword(e.target.value)} required data-testid="login-password-input"/>
            </div>
            {err && <div className="text-sm text-destructive" data-testid="login-error">{err}</div>}
            <Button type="submit" disabled={busy} className="w-full bg-primary text-primary-foreground hover:bg-primary/90" data-testid="login-submit-btn">
              {busy ? "Signing in…" : "Sign in"}
            </Button>
            <p className="text-xs text-muted-foreground">
              Demo users use password <span className="font-mono">Demo@2026</span>. Admin: <span className="font-mono">Gram@2026</span>.
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}
